import { Toast } from "antd-mobile";

// 判断路劲
export type SortOrder = "asc" | "desc" | "normal";

type UnitMappings = {
	[key: string]: string;
};

export function getLogo(unit: string) {
	const unitMappings: UnitMappings = {
		ADA: "ADA",
		ASTRA: "ASTRA",
		AUSDC: "AUSDC",
		AUSDT: "AUSDT",
		AWBTC: "AWBTC",
		BCH: "BCH",
		BTC: "BTC",
		BNB: "BNB",
		DOGE: "DOGE",
		DOT: "DOT",
		ETH: "ETH",
		MATIC: "MATIC",
		MZLC: "MZLC",
		SOL: "SOL",
		QZLC: "QZLC",
		TRX: "TRX",
		XRP: "XRP",
		ZLC: "ZLC",
	};
	const logoPath = unitMappings[unit] || "";
	if (logoPath) {
		return logoPath;
	}
	return null;
}

interface sortTpey {
	[key: string]: string | number;
}

export function sortByData<T extends sortTpey>(
	array: T[],
	key: string,
	sortOrder: SortOrder = "asc",
	tragetVal?: any[]
): T[] {
	if (sortOrder === "normal" && tragetVal?.length) {
		return array.sort((a, b) => {
			const valueA = a[key];
			const valueB = b[key];
			return tragetVal.indexOf(valueA) - tragetVal.indexOf(valueB);
		});
	}
	return array.sort((a, b) => {
		const valueA = a[key];
		const valueB = b[key];
		let result: number;
		if (key === "unit") {
			result = String(valueA).localeCompare(String(valueB), undefined, {
				sensitivity: "base",
			});
		} else {
			result = +valueA - +valueB;
		}
		return sortOrder === "desc" ? -result : result;
	});
}

export function formatVolume(volume: number): string {
	const units = ["", "K", "M", "B", "T", "P", "E", "Z", "Y"];
	let i = 0;
	while (volume >= 1000 && i < units.length - 1) {
		volume /= 1000;
		i++;
	}
	return volume?.toFixed(2) + units[i];
}

function isNullOrUndefined(value: unknown): value is null | undefined {
	return value === null || value === undefined;
}

export function addThousandsSeparator(
	num: any,
	maxDecimalPlaces: number = 2
): string {
	if (isNullOrUndefined(num)) {
		num = "0";
	}
	if (typeof num === "string") {
		num = parseFloat(num);
	}

	num = num.toFixed(maxDecimalPlaces);
	let arrData = num.split(".");
	if (arrData.length > 1) {
		while (num.split(".")[1].length < maxDecimalPlaces) {
			num += "0";
		}
	} else {
		let decimalPart = "";
		while (decimalPart.length < maxDecimalPlaces) {
			decimalPart += "0";
		}
		num = "." + decimalPart;
	}

	return Number(num).toLocaleString(undefined, {
		minimumFractionDigits: maxDecimalPlaces,
		maximumFractionDigits: maxDecimalPlaces,
	});
}

export function roundToDecimalPlaces(
	inputNumber: number,
	decimalPlaces: number
): number {
	if (decimalPlaces < 0) {
		throw new Error("decimalPlaces 参数必须大于等于 0");
	}
	const multiplier = Math.pow(10, decimalPlaces);
	const roundedNumber = Math.round(inputNumber * multiplier) / multiplier;

	return roundedNumber;
}

export function isEmpty(val: any) {
	if (
		val == null ||
		typeof val === "undefined" ||
		val === undefined ||
		val === "undefined" ||
		("" + val).toUpperCase() === "NULL" ||
		"" + val === ""
	) {
		return true;
	}
	if (typeof val === "boolean") {
		return !val;
	}
	if (val instanceof Error) return val.message === "";
	switch (Object.prototype.toString.call(val)) {
		// String or Array
		case "[object String]":
		case "[object Array]":
			return !val.length;
		case "[object File]":
		case "[object Map]":
		case "[object Set]":
			return !val.size;
		case "[object Object]":
			return !Object.keys(val).length;
	}

	return false;
}

// 格式化时间的格式
export function dateFormat(timestamp: number, format: string): string {
	const date = convertTimestampToCurrentTimezone(timestamp);
	const o: Record<string, number> = {
		"M+": date.getMonth() + 1,
		"d+": date.getDate(),
		"h+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds(),
		"q+": Math.floor((date.getMonth() + 3) / 3),
		S: date.getMilliseconds(),
	};

	if (/([Yy]+)/.test(format)) {
		format = format.replace(
			RegExp.$1,
			(date.getFullYear() + "").substr(4 - RegExp.$1.length)
		);
	}

	for (const k in o) {
		if (new RegExp("(" + k + ")").test(format)) {
			format = format.replace(
				RegExp.$1,
				RegExp.$1.length === 1
					? o[k].toString()
					: ("00" + o[k]).substr(("" + o[k]).length)
			);
		}
	}

	return format;
}

export function toFixed(number: any) {
	return toNumberFixed(number, 2);
}

export function toNumberFixed(number: any, decimal: number) {
	if (!number) return "0.00";
	if (typeof number == "string") {
		number = parseFloat(number);
	}
	let decimalNumber = 10 ** decimal;
	let value = (number * decimalNumber).toFixed(decimal);
	value = (parseInt(value) / decimalNumber).toFixed(decimal);
	return value;
}

//获取粘贴板
export async function fetchCopiedText() {
	try {
		// 使用 Clipboard API 读取剪贴板文本
		const text = await navigator.clipboard.readText();
		console.log("从剪贴板读取的文本:", text);
		return text;
	} catch (e) {
		console.log("获取剪贴板异常", e);
		return null;
	}
}

export async function copyToClipboard(text: string) {
	try {
		await navigator.clipboard.writeText(text);
		return true;
	} catch (e) {
		console.log("复制到剪贴板异常", e);
		return false;
	}
}

export function getUuid() {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
		.replace(/[xy]/g, function (c) {
			var r = (Math.random() * 24) | 0,
				v = c === "x" ? r : (r & 0x3) | 0x8;
			return v.toString(24);
		})
		.replace(/-/g, "");
}

export function getTickClassName(value: string) {
	if (isEmpty(value)) return;
	let className = "";
	switch (value) {
		case "PlusTick":
		case "ZeroPlusTick":
			className = "long";
			break;
		case "MinusTick":
		case "ZeroMinusTick":
			className = "short";
			break;
	}
	return className;
}

function getTimeValue(key: string) {
	const Language = localStorage.getItem("Language");
	const langData: any = {
		en: {
			monthAgo: "month ago",
			weekAgo: "week ago",
			dayAgo: "day ago",
			hourAgo: "hour ago",
			minutesAgo: "minutes ago",
			just: "just",
		},
		zh_CN: {
			monthAgo: "月前",
			weekAgo: "周前",
			dayAgo: "天前",
			hourAgo: "小时前",
			minutesAgo: "分钟前",
			just: "刚刚",
		},
		zh_HK: {
			monthAgo: "月前",
			weekAgo: "週前",
			dayAgo: "天前",
			hourAgo: "小時前",
			minutesAgo: "分鐘前",
			just: "剛剛",
		},
	};
	if (Language) {
		return langData[Language][key];
	} else {
		return langData["en"][key];
	}
}

export function formatTimeover(dateTime: string) {
	let minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
	let hour = minute * 60;
	let day = hour * 24;
	let week = day * 7;
	// let halfamonth = day * 15;
	let month = day * 30;
	let now = new Date().getTime(); //获取当前时间毫秒
	const dateTimeStamp: number = new Date(
		dateTime.replace(/-/g, "/")
	).getTime();
	let diffValue = now - dateTimeStamp; //时间差

	if (diffValue < 0) {
		return;
	}

	let minC = diffValue / minute; //计算时间差的分，时，天，周，月
	let hourC = diffValue / hour;
	let dayC = diffValue / day;
	let weekC = diffValue / week;
	let monthC = diffValue / month;
	let result = "-";
	if (monthC >= 1 && monthC <= 3) {
		result =
			" " +
			parseInt(monthC.toString(), 10) +
			" " +
			getTimeValue("monthAgo");
	} else if (weekC >= 1 && weekC <= 3) {
		result =
			" " +
			parseInt(weekC.toString(), 10) +
			" " +
			getTimeValue("weekAgo");
	} else if (dayC >= 1 && dayC <= 6) {
		result =
			" " + parseInt(dayC.toString(), 10) + " " + getTimeValue("dayAgo");
	} else if (hourC >= 1 && hourC <= 23) {
		result =
			" " +
			parseInt(hourC.toString(), 10) +
			" " +
			getTimeValue("hourAgo");
	} else if (minC >= 1 && minC <= 59) {
		result =
			" " +
			parseInt(minC.toString(), 10) +
			" " +
			getTimeValue("minutesAgo");
	} else if (diffValue >= 0 && diffValue <= minute) {
		result = getTimeValue("just");
	} else {
		let datetime = new Date();
		datetime.setTime(dateTimeStamp);
		let Nyear = datetime.getFullYear();
		let Nmonth =
			datetime.getMonth() + 1 < 10
				? "0" + (datetime.getMonth() + 1)
				: datetime.getMonth() + 1;
		let Ndate =
			datetime.getDate() < 10
				? "0" + datetime.getDate()
				: datetime.getDate();
		let Nhour =
			datetime.getHours() < 10
				? "0" + datetime.getHours()
				: datetime.getHours();
		let Nminute =
			datetime.getMinutes() < 10
				? "0" + datetime.getMinutes()
				: datetime.getMinutes();
		let Nsecond =
			datetime.getSeconds() < 10
				? "0" + datetime.getSeconds()
				: datetime.getSeconds();
		result =
			Nyear +
			"-" +
			Nmonth +
			"-" +
			Ndate +
			" " +
			Nhour +
			":" +
			Nminute +
			":" +
			Nsecond;
	}
	return result;
}

export function setDataToClipboard(
	text: string,
	successText: string = "Copy successful"
) {
	if (!text) {
		return;
	}
	const fakeElem = document.createElement("textarea");
	fakeElem.style.position = "absolute";
	fakeElem.style.border = "0";
	fakeElem.style.padding = "0";
	fakeElem.style.margin = "0";
	fakeElem.style.top = "0px";
	fakeElem.style.right = "0px";
	fakeElem.style.bottom = "0px";
	fakeElem.style.left = "0px";
	fakeElem.value = text;
	document.body.appendChild(fakeElem);
	fakeElem.select();
	fakeElem.setSelectionRange(0, fakeElem.value.length);
	document.execCommand("copy");
	document.body.removeChild(fakeElem);
	Toast.show({
		content: successText,
		position: "top",
	});
}

// 将十六进制字符串转换为 Uint8Array
export function hexToUint8Array(hexString: string) {
	const bytes = [];
	for (let i = 0; i < hexString.length; i += 2) {
		bytes.push(parseInt(hexString.substr(i, 2), 16));
	}
	return new Uint8Array(bytes);
}

export function partiallyHideHash(
	hash: string,
	prefixLength: number = 5,
	suffixLength: number = 4
) {
	if (hash.length <= prefixLength + suffixLength) {
		return hash; // 如果哈希长度小于等于指定的前缀和后缀长度之和，则不进行隐藏
	}

	const prefix = hash.slice(0, prefixLength);
	const suffix = hash.slice(-suffixLength);

	const hiddenPart = "..."; // 隐藏部分的标记，你可以根据需要自定义

	return `${prefix}${hiddenPart}${suffix}`;
}

// "Record":"记录",
//   "RechargeRecord": "充值记录",
//   "WDRecord": "提币记录",
//   "all":"全部",
//   "WithdrawalRecharge":"已发起提现/充值申请",
//   "CalledAddress":"已回调,等待转出到目标地址",
//   "transferCommit":"转出提交",
//   "transferOutCompleted":"转出已回调(流程完结)",
//   "reviewTokens":"已扣除代币,等待审核",
//   "refundedRefunded":"已退款(提现审核不过,需要退款)"
export function getStatusText(statusCode: number) {
	switch (statusCode) {
		case 1:
			return "WithdrawalRecharge";
		case 2:
			return "CalledAddress";
		case 3:
			return "transferCommit";
		case 4:
			return "transferOutCompleted";
		case 0:
			return "reviewTokens";
		case -1:
			return "refundedRefunded";
		default:
			return "-";
	}
}

export function getInfoFromUserAgent(keyword: string) {
	var match = navigator.userAgent.match(new RegExp(keyword + "\\/(\\S+)"));
	return match ? match[1] : null;
}

// 是否是IOS
export function isIos() {
	return /ios|iphone|ipad|ipod/.test(
		window.navigator.userAgent.toLowerCase()
	);
}

// 是否是安卓
export function isAndroid() {
	return /android/.test(window.navigator.userAgent.toLowerCase());
}

// 判断路劲
export function isValidURL(url: string) {
	const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
	return urlPattern.test(url);
}

export function getBaseURL() {
	const currentProtocol = window.location.protocol;
	const currentHostname = window.location.hostname;
	const currentPort = window.location.port;
	const baseURL = `${currentProtocol}//${currentHostname}${
		currentPort ? `:${currentPort}` : ""
	}`;
	return baseURL;
}

export function truncateString(str: string, maxLength: number) {
	if (str.length <= maxLength) {
		return str;
	} else {
		const start = str.slice(0, 4);
		const end = str.slice(-4);
		return `${start}**${end}`;
	}
}

export const handleBrowserUrl = (unit: string, transNo: string) => {
	if (isEmpty(transNo) || isEmpty(unit)) return "-";
	if (unit.toLocaleUpperCase().startsWith("TRON")) {
		return "https://tronscan.org/#/transaction/" + transNo;
	}
	if (unit.toLocaleUpperCase().startsWith("ETH")) {
		return "https://etherscan.io/tx/" + transNo;
	}
	return "-";
};

export function multiplyWithPrecision(
	num1: number,
	num2: number,
	precision: number
) {
	const multiplier = Math.pow(10, precision);
	const result = (num1 * multiplier - num2 * multiplier) / multiplier;
	return result;
}

export function pxToRem(pxValue: number, remUnit: number = 37.5): string {
	return `${(pxValue / remUnit).toFixed(6)}rem`;
}

export function getNextSevenDaysWithDateInfo(startDate: Date, numDays: number) {
	// 往后推7天：
	// console.log(getNextSevenDays(new Date(), 7));
	// 往前推7天：
	// console.log(getNextSevenDays(new Date(), -7));
	const getNextSevenDays = (startDate: Date, numDays: number): Date[] => {
		let days: Date[] = [];
		for (let i = 0; i < Math.abs(numDays); i++) {
			startDate = convertTimestampToCurrentTimezone(startDate.getTime());
			let nextDate = new Date(startDate);
			nextDate.setDate(startDate.getDate() + (numDays > 0 ? i : -i));
			days.push(nextDate);
		}
		return days;
	};

	let result = [];
	let sevenDays = getNextSevenDays(startDate, numDays);

	for (let i = 0; i < sevenDays.length; i++) {
		let currentDate = sevenDays[i];
		let year = currentDate.getFullYear();
		let month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
		let day = currentDate.getDate().toString().padStart(2, "0");
		let dateStr = year + "-" + month + "-" + day;

		let daysOfWeek = [
			"星期日",
			"星期一",
			"星期二",
			"星期三",
			"星期四",
			"星期五",
			"星期六",
		];
		let dayOfWeek = daysOfWeek[currentDate.getDay()];

		result.push([dateStr, dayOfWeek]);
	}

	return result;
}

/**
 * 格式化金額，添加千位符
 * @param amount 需要格式化的金額，可以是數字或字符串
 * @param options 可選配置項
 * @returns 格式化後的金額字符串
 */
export function formatNumberWithCommas(
	amount: number | string,
	options: {
		/** 小數點後保留的位數，默認為 2 */
		decimalPlaces?: number;
		/** 千位分隔符，默認為逗號 ',' */
		thousandsSeparator?: string;
		/** 小數點符號，默認為點 '.' */
		decimalPoint?: string;
		/** 是否始終顯示小數部分，即使為零，默認為 true */
		alwaysShowDecimals?: boolean;
	} = {}
): string {
	// 設置默認值
	const decimalPlaces = options.decimalPlaces ?? 2;
	const thousandsSeparator = options.thousandsSeparator ?? ",";
	const decimalPoint = options.decimalPoint ?? ".";
	const alwaysShowDecimals = options.alwaysShowDecimals ?? true;

	// 將輸入轉換為數字
	let num: number;

	// 處理 null 或 undefined
	if (isNullOrUndefined(amount)) {
		return "0.00";
	}

	if (typeof amount === "string") {
		// 移除字符串中的非數字字符（保留小數點）
		const cleanedAmount = amount.replace(/[^\d.-]/g, "");
		num = parseFloat(cleanedAmount);
	} else {
		num = amount;
	}

	// 檢查是否為有效數字
	if (isNaN(num)) {
		return "0.00";
	}

	// 處理 Infinity
	if (!isFinite(num)) {
		return num > 0 ? "Infinity" : "-Infinity";
	}

	// 處理小數部分
	let formattedAmount: string;

	if (alwaysShowDecimals || decimalPlaces > 0) {
		// 固定小數位數
		formattedAmount = num.toFixed(decimalPlaces);
	} else {
		// 不顯示小數
		formattedAmount = Math.round(num).toString();
	}

	// 分離整數和小數部分
	const parts = formattedAmount.split(".");

	// 處理整數部分，添加千位符
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

	// 重新組合整數和小數部分
	return parts.length > 1
		? `${parts[0]}${decimalPoint}${parts[1]}`
		: parts[0];
}

// 老牌
export function formatTimestamp(timestamp: number): string {
	const date = new Date(timestamp);
	// 获取年、月、日、时、分
	// const year = date.getFullYear();
	const month = date.getMonth() + 1; // 月份是从0开始计数的，所以要加1
	const day = date.getDate();
	const hours = date.getHours();
	const minutes = date.getMinutes();
	// 格式化月份和分钟，确保是两位数
	const formattedMonth = month < 10 ? `0${month}` : `${month}`;
	const formattedDay = day < 10 ? `0${day}` : `${day}`;
	const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
	const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
	// 返回格式化后的日期时间字符串 ${year}-
	return `${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}`;
}

export const getStartOfDay = (offset: number = 0): string => {
	const today = convertTimestampToCurrentTimezone(Date.now());
	const targetDate = new Date(today.setDate(today.getDate() + offset));
	targetDate.setHours(0, 0, 0, 0);
	let year = targetDate.getFullYear();
	let month = (targetDate.getMonth() + 1).toString().padStart(2, "0");
	let day = targetDate.getDate().toString().padStart(2, "0");
	return year + "-" + month + "-" + day + " 00:00:00";
};

export const getEndOfDay = (offset: number = 0): string => {
	const today = convertTimestampToCurrentTimezone(Date.now());
	const targetDate = new Date(today.setDate(today.getDate() + offset));
	targetDate.setHours(23, 59, 59, 999);
	let year = targetDate.getFullYear();
	let month = (targetDate.getMonth() + 1).toString().padStart(2, "0");
	let day = targetDate.getDate().toString().padStart(2, "0");
	return year + "-" + month + "-" + day + " 23:59:59";
};

export const _runTask = (task: () => void, callback?: () => void): void => {
	const start = Date.now();
	const run = (): void => {
		if (Date.now() - start < 16.6) {
			task();
			callback && callback();
		} else {
			_runTask(run, callback);
		}
	};
	requestAnimationFrame(run);
};

export const rmbToUsd = (rmbAmount: number, exchangeRate: number) => {
	return rmbAmount / exchangeRate;
};

export function formatBankCardNumber(cardNumber: string): string {
	const visiblePart = cardNumber.slice(0, 4);
	const hiddenPart = "****";
	const lastPart = cardNumber.slice(-4);
	return `${visiblePart}${hiddenPart}${lastPart}`;
}

export function convertTimestampToCurrentTimezone(timestamp: number) {
	// 创建 Date 对象，并将时间戳传递给构造函数
	const date = new Date(timestamp);
	// 将时间转换为世界标准时间 (UTC)
	const utcTimestamp = date.getTime() + date.getTimezoneOffset() * 60000;
	// 获取当前时区偏移量（以分钟为单位）
	const timezoneOffset = new Date().getTimezoneOffset();
	// 计算当前时区的时间戳
	const currentTimestamp = utcTimestamp - timezoneOffset * 60000;
	// 创建当前时区时间对象
	const localDate = new Date(currentTimestamp);
	// 获取本地时间的年、月、日、时、分、秒
	// const year = localDate.getFullYear();
	// const month = localDate.getMonth() + 1; // 月份从0开始，需要加1
	// const day = localDate.getDate();
	// const hour = localDate.getHours();
	// const minute = localDate.getMinutes();
	// const second = localDate.getSeconds();

	// 返回本地时间字符串
	return localDate;
}
export function calculatePercentage(part: number, whole: number): number {
	// 计算百分比
	const percentage: number = ((part ?? 0) / (whole || 1)) * 100;
	return parseInt(percentage.toString()); //parseFloat(percentage.toFixed(2));
}
export const getRiskColosPercentage = (percentage: number): string => {
	if (percentage >= 0 && percentage < 25) {
		return "#0F55E8";
	} else if (percentage >= 25 && percentage < 50) {
		return "#E86A0F";
	} else if (percentage >= 50 && percentage < 75) {
		return "#E86A0F";
	} else if (percentage >= 75 && percentage <= 100) {
		return "#FF6161";
	} else {
		return "#FF6161"; // 如果超出范围，返回空
	}
};

export const getColorByNumber = (number: number): string => {
	if (number > 0) {
		return "win";
	} else if (number < 0) {
		return "lose";
	} else {
		return "";
	}
};

function isGMT8(date: Date, zone: number = 8): boolean {
	// 获取给定日期的时区偏移
	const offset = date.getTimezoneOffset() / 60;
	// 如果时区偏移为 -8，则表示在东八区
	return offset === zone * -1;
}

export function convertToGMT8(date: Date, zone: number = 8): Date {
	if (isGMT8(date, zone)) {
		return date; // 如果是东八区时间，直接返回
	} else {
		const offsetInMilliseconds = date.getTimezoneOffset() * 60 * 1000; // 获取当前时区偏移的毫秒数
		const gmt8OffsetInMilliseconds = zone * 60 * 60 * 1000; // 东八区偏移的毫秒数
		return new Date(
			date.getTime() + offsetInMilliseconds + gmt8OffsetInMilliseconds
		); // 加上东八区偏移量
	}
}

export function east8ToEast9(dateStr: string) {
	var offset = 9;
	var targetTime = new Date(dateStr);
	var utc = targetTime.getTime() + -28800000; //targetTime.getTimezoneOffset()东八区=-28800000
	var actualTime = new Date(utc + 3600000 * offset);
	return actualTime;
}

// 安全区
export function getStatusBarHeight() {
	let statusBarHeight = 0;
	if (window.visualViewport) {
		statusBarHeight = window.visualViewport.offsetTop;
	} else if (
		window.screen &&
		window.matchMedia("(display-cutout: constant)").matches
	) {
		const devicePixelRatio = window.devicePixelRatio;
		statusBarHeight = Math.round(24 * devicePixelRatio); // 这里的24需要根据设备实际情况进行调整
	}
	return statusBarHeight;
}
